const ITEMS = [
  "PROUDLY SERVING THE 614",
  "COLUMBUS",
  "WORTHINGTON",
  "DUBLIN",
  "UPPER ARLINGTON",
  "CLINTONVILLE",
  "GRANDVIEW",
  "BEXLEY",
  "HILLIARD",
  "WESTERVILLE",
  "GAHANNA",
  "GROVE CITY",
  "POWELL",
  "PICKERINGTON",
  "REYNOLDSBURG",
  "INSIDE THE 270 OUTERBELT + RING SUBURBS",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="select-none overflow-hidden border-y border-stone-800 bg-[#141210] py-4"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-stone-400"
              >
                <span className="px-6">{item}</span>
                <span className="text-amber-500">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
